import clsx from 'clsx';

export let classNames = clsx;
